<template>
    <div class="py-10">
        <div class="flex flex-col pt-4 relative max-w-5xl mx-auto">
            <div class="flex-1 transition-all">
                <header class="mb-8 px-3 flex">
                    <div>
                        <h3
                            class="text-slate-800 dark:text-slate-100 font-bold text-2xl lg:text-3xl xl:text-4xl leading-10"
                        >
                            {{ course?.title }}
                        </h3>
                        <div
                            class="pt-4 prose text-slate-500 dark:text-slate-400"
                            v-safe-html="course?.description"
                        ></div>
                    </div>
                    <!-- Orange travel graphic: -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="88"
                        height="88"
                        fill="none"
                    >
                        <path
                            fill="url(#a)"
                            fill-rule="evenodd"
                            d="M38.513 1.998A17.151 17.151 0 0 0 20.78 13.311a5.773 5.773 0 0 0 3.946 7.615l16.345 5.26c.56.199.99.654 1.156 1.224l2.592 8.887a3.763 3.763 0 0 0 2.497 2.594l.007.002 7.401 2.383.003.001a3.826 3.826 0 0 0 4.947-4.31L58.49 31.27l14.704 4.786a5.711 5.711 0 0 0 7.245-3.536l5.463-16.814c.129-.393.38-1.164.226-2a3.637 3.637 0 0 0-2.295-2.744l-6.286-2.137a3.638 3.638 0 0 0-4.173 1.39l-.005.008a2.224 2.224 0 0 0-.016.025l-1.025 1.586a5.833 5.833 0 0 1-7.508 2.052L45.596 4.274a17.151 17.151 0 0 0-7.083-2.276Zm3.526 21.349-.49 1.417.46-1.428-16.407-5.28a1.504 1.504 0 0 0-.093-.026 2.774 2.774 0 0 1-1.917-3.672l.01-.028a14.152 14.152 0 0 1 20.516-7.445c.03.018.06.034.091.05l19.268 9.633a8.833 8.833 0 0 0 11.37-3.107l1.01-1.564a.637.637 0 0 1 .723-.233l6.235 2.12a.638.638 0 0 1 .361.461c0 .007.002.04-.012.117a3.8 3.8 0 0 1-.13.457l-5.442 16.753a2.711 2.711 0 0 1-3.434 1.643l-.025-.009-15.912-5.179a2.27 2.27 0 0 0-2.925 2.62l1.432 6.888a.825.825 0 0 1-1.075.889l-7.422-2.39-.011-.004a.762.762 0 0 1-.508-.53l-.003-.008-.006-.022-2.596-8.9a4.847 4.847 0 0 0-3.068-3.223Z"
                            clip-rule="evenodd"
                        />
                        <path
                            fill="url(#b)"
                            fill-rule="evenodd"
                            d="M34.54 42.45a1.5 1.5 0 0 0-2.702-1.304 11.558 11.558 0 0 0-.332 9.296l.006.016a11.054 11.054 0 0 0 10.292 6.858 3.34 3.34 0 0 1 3.336 3.34V81.42a29.93 29.93 0 0 1-18.497.859V67.948a11.182 11.182 0 0 0-11.45-11.181H4.83a29.928 29.928 0 0 1 10.287-26.09 1.5 1.5 0 0 0-1.95-2.28 32.928 32.928 0 0 0 33.776 55.54c.19-.04.366-.115.522-.218A32.92 32.92 0 0 0 63.46 69.226 32.93 32.93 0 0 0 67.5 53.423a1.5 1.5 0 0 0-3 0 29.929 29.929 0 0 1-16.36 26.674V60.656a6.34 6.34 0 0 0-6.34-6.34h-.01a8.055 8.055 0 0 1-7.5-4.99 8.559 8.559 0 0 1 .25-6.875ZM5.323 59.768a29.93 29.93 0 0 0 18.319 21.515V67.947a8.184 8.184 0 0 0-5.197-7.62 8.182 8.182 0 0 0-3.235-.56H5.324Z"
                            clip-rule="evenodd"
                        />
                        <defs>
                            <radialGradient
                                id="a"
                                cx="0"
                                cy="0"
                                r="1"
                                gradientTransform="matrix(12.99999 68 -113.48673 21.69597 33 28)"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FD421D" />
                                <stop offset="1" stop-color="#FAB34A" />
                            </radialGradient>
                            <radialGradient
                                id="b"
                                cx="0"
                                cy="0"
                                r="1"
                                gradientTransform="matrix(12.99999 68 -113.48673 21.69597 33 28)"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FD421D" />
                                <stop offset="1" stop-color="#FAB34A" />
                            </radialGradient>
                        </defs>
                    </svg>
                </header>

                <div class="mb-16 px-3">
                    <ProgressBar class="mb-5" />
                    <StartNextChapter />
                </div>

                <h4 class="text-slate-800 dark:text-slate-100 text-lg font-medium mb-8 px-3">
                    Course Lessons
                </h4>

                <ChapterList />
            </div>
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { usePage } from '@inertiajs/vue3';
import { onMounted, onUnmounted, watch, ref } from 'vue';
import { useCoursesStore } from '@/store/courses';
import { useDashboardStore } from '@/store/dashboard';
import { generateUUID } from '@/utils/uuid.js';
import { useCourseChatbot } from '@/composables/useCourseChatbot';
import Chapter from '@/components/courses/chapter.vue';
import ProgressBar from '@/components/courses/progress-bar.vue';
import StartNextChapter from '@/components/courses/start-next-chapter.vue';
import ChapterList from '@/components/courses/chapter-list/list.vue';

const store = useCoursesStore();
const dashboardStore = useDashboardStore();
const { showChatbot } = useCourseChatbot();
const page = usePage();
const { course, loadingCourse } = storeToRefs(store);
const trackingEventsFired = ref(false); // Flag to prevent duplicate event firing

const childComponents = {
    Chapter,
};

// Function to handle event firing
const fireTrackingEvents = () => {
    if (trackingEventsFired.value) {
        return;
    }
    if (
        course.value &&
        dashboardStore.user &&
        dashboardStore.user.hashed_email_sha256 &&
        dashboardStore.user.uuid
    ) {
        // Backend tracking - always fire (not just in production)
        trackCoursePageView();

        if (
            import.meta.env.VITE_APP_ENV === 'production' &&
            typeof fbq !== 'undefined'
        ) {
            const event_id = generateUUID();

            // Facebook Pixel Event
            fbq(
                'track',
                'ViewContent',
                {
                    content_name: course.value.title,
                    content_ids: [course.value.slug],
                    content_category: 'Course',
                    content_type: 'product',
                    em: dashboardStore.user.hashed_email_sha256,
                    external_id: dashboardStore.user.uuid,
                },
                { eventID: event_id }
            );

            // Woopra Event
            if (typeof woopra !== 'undefined') {
                // Identify the user for Woopra
                if (
                    dashboardStore.user &&
                    dashboardStore.user.email &&
                    dashboardStore.user.uuid
                ) {
                    woopra.identify({
                        email: dashboardStore.user.email,
                        uuid: dashboardStore.user.uuid,
                    });
                }

                woopra.track('visit_course_page', {
                    email: dashboardStore.user.email,
                    uuid: dashboardStore.user.uuid,
                    course_title: course.value.title,
                    course_slug: course.value.slug,
                    course_id: course.value.id,
                    fb_event_id: event_id,
                });
            }
            // Set the flag to prevent duplicate events
            trackingEventsFired.value = true;
        }
    }
};

// Backend tracking function
const trackCoursePageView = async () => {
    if (!course.value || !dashboardStore.user) {
        return;
    }

    try {
        // Call backend tracking endpoint with course UUID
        await window.axios.post(`/api/courses/${course.value.uuid}/track-view`);
    } catch (error) {
        // Silently fail - don't break page if tracking fails
        console.error('Course page view tracking failed:', error);
    }
};

// Set on unmount so a load that finishes after the member has left stops.
let isUnmounted = false;

onMounted(async () => {
    showChatbot();

    // Read the prop before awaiting: if the member navigates away meanwhile,
    // page.props belongs to the next page (MY10X-1QA).
    const courseData = page.props.course?.data;

    // Ensure user data is loaded
    // Use getUsersOnly() instead of getUsers() to avoid loading dashboard cards
    // which aren't needed on the course page
    if (!dashboardStore.user) {
        try {
            await dashboardStore.getUsersOnly();
        } catch (error) {
            console.error(
                'Error calling dashboardStore.getUsersOnly() in course.vue onMounted:',
                error
            );
        }
    }

    // The member left while the user loaded and the cleanup has run, so don't
    // restore this course or track it.
    if (isUnmounted) {
        return;
    }

    if (courseData) {
        store.setCourse(courseData);
    }

    fireTrackingEvents();
});

watch(
    () => dashboardStore.user,
    (newUser, oldUser) => {
        if (newUser && course.value) {
            fireTrackingEvents();
        }
    },
    { deep: true }
);

watch(course, (newCourse, oldCourse) => {
    if (newCourse && dashboardStore.user) {
        fireTrackingEvents();
    }
});

onUnmounted(() => {
    isUnmounted = true;
});
</script>
